import { useEffect } from 'react';
import { useAuth, useSession, useUser } from '@clerk/clerk-react';
import { useOrganizationContext } from '@/contexts/OrganizationContext';
import { userActivityService } from '@/services/UserActivityService';
import { useLocation } from 'react-router-dom';

/**
 * Hook to integrate user activity tracking with Clerk sessions
 * Automatically initializes tracking when user logs in and cleans up on logout
 */
export function useActivityTracking() {
  const { isSignedIn, userId } = useAuth();
  const { session } = useSession();
  const { user } = useUser();
  const { 
    userProfileId, 
    currentOrganizationId, 
    currentOrganizationSettings 
  } = useOrganizationContext();
  const location = useLocation();
  
  // Initialize session tracking when user signs in
  // TEMPORARILY DISABLED: Causing cascade of failed 401/429 requests
  useEffect(() => {
    if (!isSignedIn || !userId || !session?.id) return;
    
    // const initTracking = async () => {
    //   // Get idle timeout from org settings or use default
    //   const idleTimeout = currentOrganizationSettings?.idle_timeout_minutes || 30;
    //   
    //   await userActivityService.initializeSession(
    //     userId,
    //     session.id,
    //     userProfileId || undefined,
    //     currentOrganizationId || undefined,
    //     idleTimeout
    //   );
    // };
    // 
    // initTracking();
    
    // Listen for idle timeout events
    const handleIdleTimeout = () => {
      // Sign out user on idle timeout
      if (window.Clerk) {
        window.Clerk.signOut();
      }
    };
    
    window.addEventListener('idle-timeout', handleIdleTimeout);
    
    // Cleanup on unmount or sign out
    return () => {
      window.removeEventListener('idle-timeout', handleIdleTimeout);
      if (!isSignedIn) {
        userActivityService.endSession('User signed out');
      }
    };
  }, [isSignedIn, userId, session?.id, userProfileId, currentOrganizationId, currentOrganizationSettings]);
  
  // Track page views on route changes
  // TEMPORARILY DISABLED: Causing cascade of failed 401 requests
  useEffect(() => {
    if (!isSignedIn || !session?.id) return;
    
    // userActivityService.trackPageView(location.pathname, {
    //   search: location.search,
    //   hash: location.hash
    // });
  }, [location, isSignedIn, session?.id]);
  
  // Update organization context when it changes
  // TEMPORARILY DISABLED: Causing cascade of failed 401 requests
  useEffect(() => {
    if (!isSignedIn || !session?.id) return;
    
    // // Update service with new organization context
    // const service = userActivityService as any;
    // if (service.organizationId !== currentOrganizationId) {
    //   service.organizationId = currentOrganizationId;
    //   
    //   // Log organization switch
    //   userActivityService.trackAction('Organization switched', {
    //     newOrgId: currentOrganizationId
    //   });
    // }
  }, [currentOrganizationId, isSignedIn, session?.id]);
  
  // Track session refresh
  // TEMPORARILY DISABLED: Causing cascade of failed 401 requests
  useEffect(() => {
    if (!session?.id) return;
    
    // const handleVisibilityChange = () => {
    //   if (document.visibilityState === 'visible') {
    //     userActivityService.logActivity({
    //       clerk_user_id: userId || '',
    //       clerk_session_id: session.id,
    //       activity_type: 'session_refresh',
    //       activity_description: 'User returned to active tab'
    //     });
    //   }
    // };
    // 
    // document.addEventListener('visibilitychange', handleVisibilityChange);
    // 
    // return () => {
    //   document.removeEventListener('visibilitychange', handleVisibilityChange);
    // };
  }, [session?.id, userId]);
  
  return {
    trackAction: userActivityService.trackAction.bind(userActivityService),
    trackApiCall: userActivityService.trackApiCall.bind(userActivityService)
  };
}